import CreateUserGroup from './component/create-user-group.vue';
import UserGroupExtension from './component/user-group-extension.vue';
import CreateUser from './component/create-user.vue';
import CreateCustomer from './component/create-customer.vue';
import ItemContent from './component/item-content.vue';
import AssignCustomers from './component/assign-customers.vue';

export {
  AssignCustomers,
  CreateCustomer,
  CreateUser,
  CreateUserGroup,
  ItemContent,
  UserGroupExtension,
};
